import { queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { PowerUpServiceResponseBody } from "@vendata/power-up-spec";

export const statementCreditsQuery = () => {
  return queryOptions({
    queryKey: ["credits", "statement"],
    queryFn: async (): Promise<
      PowerUpServiceResponseBody["statementCredits"][200]
    > => {
      return handleClientMethod(getClient().GET("/credits/statement"));
    },
  });
};
